var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.39594 0.489868C4.10352 0.489868 0.591553 4.00184 0.591553 8.29425C0.591553 12.5867 4.10352 16.0986 8.39594 16.0986C12.6883 16.0986 16.2003 12.5867 16.2003 8.29425C16.2003 4.00184 12.6883 0.489868 8.39594 0.489868ZM6.83506 12.1964L2.93287 8.29425L4.03329 7.19383L6.83506 9.9878L12.7586 4.06428L13.859 5.1725L6.83506 12.1964Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/doneIcon.d1ebc2f21f982ede2a2c5eddae85e6ef.svg";
export { ForwardRef as ReactComponent };